import { create } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'

export const enum TypePopup {
  UPSELL = "upsell",
  PAYMENT = "payment"
}

interface UpsellState {
    orderCode: string | null
    setOrderCode: (code: string, type: TypePopup) => void
    clearOrderCode: () => void
    type: TypePopup | null
    showFixedPopupUpsell: boolean
    setShowFixedPopupUpsell: (show: boolean) => void
    // Thời điểm hết hạn (timestamp) để đồng bộ countdown giữa các tabs
    expireAt: number | null
    setExpireAt: (timestamp: number | null) => void
}
const initialState = {
    orderCode: null,
    type: null,
    showFixedPopupUpsell: true,
    expireAt: null
}
export const useUpsellStore = create<UpsellState>()(
  devtools(
    persist(
      (set, get) => ({
        orderCode: initialState.orderCode,
        type: initialState.type,
        showFixedPopupUpsell: initialState.showFixedPopupUpsell,
        expireAt: initialState.expireAt,
        setOrderCode: (code, type) => {
          set(() => ({ orderCode: code, type: type || TypePopup.UPSELL }))
        },
        clearOrderCode: () => {
          set(() => ({ orderCode: null, expireAt: null, type: null }))
        },
        setShowFixedPopupUpsell: (show) => {
          set(() => ({ showFixedPopupUpsell: show }))
        },
        setExpireAt: (timestamp) => {
          set(() => ({ expireAt: timestamp }))
        },
      }),
      {
        name: 'upsell-storage',
        storage: createJSONStorage(() => localStorage),
        // Sync across tabs
        partialize: (state) => ({
          orderCode: state.orderCode,
          type: state.type,
          showFixedPopupUpsell: state.showFixedPopupUpsell,
          expireAt: state.expireAt,
        }),
      }
    )
  )
)

// Sync state across tabs using storage event
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'upsell-storage' && e.newValue) {
      try {
        const newState = JSON.parse(e.newValue)
        useUpsellStore.setState(newState.state)
      } catch (error) {
        console.error('Error syncing upsell store across tabs:', error)
      }
    }
  })
}
